import {
  ROUTE_VALIDATION_ORDER,
  NEW_USED_LIST,
  FINANCE_BUDGET_PAYLOAD,
  APPLICATION_STATUSES
} from '@/utils/constants';
import validations from '../../utils/validations/page-validations';
import _get from 'lodash/get';
import router from '../../router';

export function getFirstInvalidRoute(state, getters, rootState) {
  for (let i = 0; i < ROUTE_VALIDATION_ORDER.length; i++) {
    let route = ROUTE_VALIDATION_ORDER[i];
    let valid = validations[route]({
      application: state.application,
      carSearch: rootState.carSearch.selected,
      quote: rootState.quote.quote
    });
    if (!valid) {
      return route;
    }
  }
  if (ROUTE_VALIDATION_ORDER.length) {
    return ROUTE_VALIDATION_ORDER[ROUTE_VALIDATION_ORDER.length - 1];
  }
}

export function vehicleCondition(state) {
  return _get(state, 'application.metaData.customerOptions.vehicleCondition');
}

export function customerSelectionIsNew(state) {
  return vehicleCondition(state) === NEW_USED_LIST.new.value;
}

export function isQuoteAccepted(state) {
  return Boolean(_get(state, 'application.metaData.quoteId'));
}

export function isQuoteAcceptedOrOpen(state) {
  return isQuoteAccepted(state) || router.currentRoute.params.quoteId;
}

export function isApplicationStarted(state) {
  return state.application ? Boolean(state.application.applicationId) : false;
}

export function isCreditCheckCompleted(state) {
  return Boolean(_get(state, 'application.metaData.creditCheckCompleted'));
}

export function isHRApprovalRequestSent(state) {
  const metaData = state.application.metaData || {};
  return Boolean(metaData.hrApproval || metaData.hrApprovalRequestSent);
}

export function isApplicationComplete(state) {
  return state.application.applicationStatus === APPLICATION_STATUSES.complete;
}

export function financeBudgetPayload(state) {
  const customerOptions =
    _get(state, 'application.metaData.customerOptions') || {};

  return (setObj) => ({
    ...FINANCE_BUDGET_PAYLOAD,
    ...setObj,
    price: customerOptions.carValue,
    leaseTerm: customerOptions.leaseTerm,
    bodyType: customerOptions.bodyType,
    kmsPerYear: customerOptions.kmsPerYear,
    vehicleCondition: customerOptions.vehicleCondition,
    businessUse: customerOptions.businessUse,
    customer: {
      ...FINANCE_BUDGET_PAYLOAD.customer,
      annualSalary: customerOptions.annualSalary
    }
  });
}
